
namespace RioERP.Carts {
    export class CartProductsColumns {
        static columnsKey = 'Carts.CartProducts';
    }
}